export default __webpack_public_path__ + "static/media/laundry2-before-768w.04610d75.png";